<template>
  <div class="flex-container flex-column ai-center">
    <div class="section-wrapper flex-column ai-center">
      <div class="header-2 kor mg-150 text-center">
        데이터몬스터즈의<br />
        데이터바우처 성공사례
      </div>
      <div class="mg-150" />
      <div class="flex-container ai-center">
        <div class="examples-grid">
          <v-hover
            v-for="example in examples"
            :key="example.id"
            v-slot:default="{ hover }"
          >
            <v-card outlined :elevation="hover ? 5 : 0" @click="onClickExample">
              <div class="pa-5 text-center">
                <div v-html="example.content"></div>
                <div class="mt-2 text-lg">
                  <b>{{ example.header }}</b>
                </div>
              </div>
              <v-img :src="example.img" :height="200" />
            </v-card>
          </v-hover>
        </div>
      </div>
      <div class="mg-150" />
    </div>
  </div>
</template>

<script>
import ve1 from "@/assets/ve1.png";
import ve2 from "@/assets/ve2.png";
import ve3 from "@/assets/ve3.png";
import ve4 from "@/assets/ve4.png";
import ve5 from "@/assets/ve5.png";
import ve6 from "@/assets/ve6.png";

export default {
  data: () => ({
    examples: [
      {
        id: 1,
        img: ve1,
        header: "오류 발생 및 공정 지연 예측",
        content:
          "스마트 팩토리 실시간 모니터링시스템<br/>구축을 통한 실시간 현황 확인",
      },
      {
        id: 2,
        img: ve2,
        header: "신제품 개발 및 마케팅전략 수립",
        content: "뷰티 트렌드 분석 대시보드를 통한<br/>소비자 반응 실시간 확인",
      },
      {
        id: 3,
        img: ve3,
        header: "반복적인 업무의 자동화",
        content: "영문 자연어 처리를 통한<br/>학습용 단어장 자동생성기 구축",
      },
      {
        id: 4,
        img: ve4,
        header: "기업/기술 관계 수집 및 분석",
        content: "기업/기술정보 기반<br/>개체명인식 및 연관키워드 도출",
      },
      {
        id: 5,
        img: ve5,
        header: "재고 확보 및 판매실적 향상",
        content:
          "딥러닝 기반 의류 재고소진<br/>예측모델링을 통한 불필요한 재생산 방지",
      },
      {
        id: 6,
        img: ve6,
        header: "입지 요건 분석 및 추천",
        content:
          "지리정보 연계 데이터 활용 조건별 입지 분석<br/>시각화를 통한 부동산 정보 확인",
      },
    ],
  }),
  methods: {
    onClickExample() {
      this.$router.push("/insights");
    },
  },
};
</script>

<style>
.examples-grid {
  display: grid;
  grid-template-columns: repeat(3, 330px);
  gap: 40px;
}
</style>